<template>
  <div class="auth-body">
    <h1 class="auth-body__title">{{title}}</h1>
    <div class="auth-body__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  @mixin auth-background($image) {
    background: linear-gradient(
      hsla(0, 0%, 4%, 0.47),
      hsla(0, 0%, 4%, 0.47)),
      url($image) no-repeat 50% / cover;
  }

  .auth-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 5rem 1rem;
    align-items: center;
    color: #fff;
    min-height: 350px;

    @include auth-background('~@/assets/images/partner-registration-bg-sm.jpg');

    @include device-from(tablet) {
      @include auth-background('~@/assets/images/partner-registration-bg-md.jpg');

      .auth-body__content {
        width: 562px;
      }
    }

    @include device-from(desktop) {
      min-height: 700px;

      @include auth-background('~@/assets/images/partner-registration-bg-lg.jpg');
    }

    &__title {
      margin-bottom: 1rem;
      font-family: 'Gilroy';
      font-weight: 900;

      @include device-from(tablet) {
        font-size: 3.4rem;
        margin-bottom: 34px;
      }
    }
  }
</style>
